import type { ReactNode } from 'react'
import { cx } from '@/ui'

/**
 * Sayfa başlığı.
 *
 * <p>Üç parça: Geist Mono büyük harf bir üst etiket (nerede olduğunuzu söyler),
 * başlık ve tek satırlık bağlam. Üst etiket zorunlu değil — sol paneldeki
 * etkin bağlantı zaten aynı bilgiyi veriyorsa tekrar edilmez. {@code leading}
 * başlığın soluna avatar ya da simge koyar (Profil ve güvenlik).
 */
export function PageHeader({
  eyebrow, title, subtitle, actions, leading, size = 'lg',
}: {
  eyebrow?: ReactNode
  title: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
  leading?: ReactNode
  size?: 'lg' | 'md'
}) {
  return (
    <div className={cx('nx-page-header', size === 'md' && 'nx-page-header--md', leading && 'nx-page-header--center')}>
      {leading}
      <div className="nx-page-header__text">
        {eyebrow && <span className="nx-eyebrow">{eyebrow}</span>}
        <h1>{title}</h1>
        {subtitle && <div className="nx-page-header__sub">{subtitle}</div>}
      </div>
      {actions && <div className="nx-page-header__actions">{actions}</div>}
    </div>
  )
}
